export default __webpack_public_path__ + "static/media/avatar-spectator.6d395d88.png";